import Vue from 'vue'
import VueRouter from 'vue-router'
import hzInx from '../components/hzIndex.vue'
import Homepage from '../views/Homepage/Homepage.vue' //推荐频道页
import Homepage2 from '../views/Homepage/Homepage2.vue' //兴智书屋定制页
import Ebook from '../views/Ebook/E-book.vue'      //电子书
import Ebookdtl from '../views/Ebook/Ebook_dtail.vue'  //电子书详情页
import Ebookdetl from '../views/Ebook/Ebookdetail.vue'  //电子书详情页(接口)
import EbookReader from '../views/Ebook/Ebook_reader.vue'  //电子书阅读界面
import EpubReader from '../views/Ebook/Epub_reader.vue'  //电子书阅读界面
import Aubook from '../views/Audiobook/Audiobook.vue'      //有声书
import Audtl from "../views/Audiobook/Audio_dtail"  //有声书详情
import Course from '../views/Course/Course.vue'      //课程
import Couraudio from '../views/Course/Couraudio.vue' //课程详情页
import VueAudio from '../views/Course/VueAudio.vue' //课程详情页

import Freshread from '../views/Freshread/Freshread.vue'      //鲜读
import Livebook from '../views/Livebook/Livebook.vue'      //直播LIVE
import LiveDt from "../views/Livebook/Livedtail.vue"     //直播详情页
import Teachers from '../views/Teacher/Teachers.vue'      //华章师资
import Subject from '../views/Subject/Subject.vue'      //专题
import SubjectDetail from '../views/Subject/SubjectDetail.vue' //专题详情备份
import Login from '../views/Login/Login.vue'   //登录
import Yunbook from '../views/Yunbook/Yunbook.vue' //云书房
import Refinance from '../views/Personnalcenter/refinance.vue' //续费VIP
import Filtrate from '../views/Homepage/Filtrate.vue'   //综合筛选页
import Seebook from '../components/Seebook.vue'   //阅读人数页
import Searchpage from '../components/Searchpage.vue'  //搜索页

import GuestCollection from '../views/Teacher/Guest/GuestCollection.vue'   //师资 - 
import GuestDetail from '../views/Teacher/Guest/GuestDetail.vue'   //师资 - 
import GuestList from '../views/Teacher/Guest/GuestList.vue'   //师资 - 
import Invite from '../views/Teacher/Invite/Invite.vue'   //师资 - 
import InviteResult from '../views/Teacher/Invite/InviteResult.vue'   //师资 - 
import TeacherSearchpage from '../views/Teacher/SearchPage/TeacherSearchPage.vue'   //师资 - 
// import { component } from 'vue/types/umd'
import Abouts from '../components/Help/Abouts.vue'  //关于我们
import Agreem from '../components/Help/Agreem.vue'   //用户协议
import Helpcenter from '../components/Help/Helpcenter.vue' //帮助中心
// import Ceshi from '../components/ceshi.vue'  //测试页面

import readIndex from '../views/readHome/readIndex.vue' //阅读架子
import readHome from '../views/readHome/readingHome.vue' //阅读首页
import ReadingClassify from '../views/readHome/readClassify.vue' //阅读分类页
import bookRecommend from '../views/readHome/bookRecommend.vue' //新书推荐
import hotRead from '../views/readHome/hotRead.vue' //新书推荐
import themeBook from '../views/readHome/themeBook.vue' //主题书单
import booklistDetails from '../views/readHome/booklistDetails.vue' //书单详情
import idleFlipBook from '../views/readHome/idleFlipBook.vue' //闲翻书
import idleFlipBookDetails from '../views/readHome/idleFlipbookDetails.vue' //闲翻书详情
import myBookshelf from '../views/readHome/myBookshelf.vue' //我的书架
import studyReport from '../views/readHome/studyReport.vue' //学习报告


Vue.use(VueRouter)

const routes = [
  
  {
    path:'/login',
    component:Login, 
  },
  {
    path:'/ebookdet',
    component:Ebookdetl, 
  },
  {
    path:'/ebook',
    component:Ebook
  },
  {
    path:'/aubook',
    component:Aubook
  },
  {
    path:'/course',
    component:Course
  },
  {
    path:'/searchpage',
    component:Searchpage
  },
  {
    path:'/filtrate',
    name: 'filtrate',
    component:Filtrate,
    // component: resolve => import('../views/Homepage/Filtrate'),
    // // meta:{
    // //   title: '游戏说明'
    // // }
  } ,
  {
    path:'/homepage2',
    name: 'homepage2',
    component:Homepage2,
  } ,
  {
    path:'/livebook',
    component:Livebook,
    
   },
   {
    path:'/teachers',
    component:Teachers
  },
  {
    path:'/subject',
    component:Subject
  },
  // {
  //   path:'/ceshi',
  //   component: Ceshi
  // },
  {
    path:'/read/ebookrdr',
    component: EpubReader
  },
  {
    path:'/vueaudio',
    component: VueAudio
  },
  {
    path: '/homepage',
    redirect:'/homepage',
    component:hzInx,
   children:[
     {
        path:'homepage',
        component:Homepage ,
        meta:{
          // 页面标题title
          title: '首页'
        ,} 
      },
  {
    path:'/agreem',
    component:Agreem
  },
  {
    path:'/helpcenter',
    component:Helpcenter
  },
  {
    path:'/abouts',
    component:Abouts
  },
      {
        path:'/ebookdtl',
        component: Ebookdtl
      },
      {
        path:'/audtl',
        component:Audtl
      },
     
      {
        path:'/subjectDetail',
        component:SubjectDetail
      },
      {
        path:'/couraudio',
        component:Couraudio
      },
      {
        path:'/freshread',
        component:Freshread
      },
     
      {
        path:'/livedtl',
        component:LiveDt
      },
    
      {
        path:'/yunbook',
        component:Yunbook
      },
    
      {
        path:'/seebook',
        component:Seebook
      },
      
      {
        path:'/TeacherSearchpage',
        component:TeacherSearchpage
      },
      {
        path:'/GuestCollection',
        component:GuestCollection
      },
      {
        path:'/GuestDetail',
        component:GuestDetail
      },
      {
      path:'/GuestList',
      component:GuestList
    },
      {
        path:'Invite',
        component:Invite
      },
      {
        path:'InviteResult',
        component:InviteResult
      },
      
      
    ]
  },
    /** 新增加机工阅读 */
      {
        path:'/',
        redirect:'/read/readIndex',
        component:readIndex,
        children:[
          {
            path:'/read/readIndex',
            component:readHome,
            meta:{
              title: '阅读首页',
              pos: 0
            }
          },
          {
            path:'/read/ReadingClassify',
            component:ReadingClassify,
            meta:{
              title: '阅读分类',
              pos: 5
            }
          },
          {
            path:'/read/bookRecommend',
            component:bookRecommend,
            meta:{
              title: '新书推荐',
            }
          },
          {
            path:'/read/hotRead',
            component:hotRead,
            meta:{
              title: 'TOP热读'
            }
          },
          {
            path:'/read/themeBook',
            component:themeBook,
            meta:{
              title: '主题书单',
              pos: 6,
            }
          },
          {
            path:'/read/booklistDetails',
            component:booklistDetails,
            meta:{
              title: '书单详情',
              pos: 6,
            }
          },
          {
            path:'/read/idleFlipBook',
            component:idleFlipBook,
            meta:{
              title: '闲翻书',
            }
          },
          {
            path:'/read/idleFlipBookDetails',
            component:idleFlipBookDetails,
            meta:{
              title: '闲翻书详情',
            }
          },
          {
            path:'/read/myBookshelf',
            component:myBookshelf,
            meta:{
              title: '我的书架',
            }
          },
          {
            path:'/read/studyReport',
            component:studyReport,
            meta:{
              title: '学习报告',
            }
          },
          
        ]
      }



  //   {
  //   path:'/GuestList',
  //   component:GuestList
  // },
  //     {
  //       path:'/GuestCollection',
  //       component:GuestCollection
  //     },
  //     {
  //       path:'/GuestDetail',
  //       component:GuestDetail
  //     },
  //     {
  //       path:'/Invite',
  //       component:Invite
  //     },
  //     {
  //       path:'/InviteResult',
  //       component:InviteResult
  //     },
  //     {
  //       path:'/SearchPage',
  //       component:SearchPage
  //     },




  // {
  //   path:'/GuestDetail',
  //   component:GuestDetail
  // },

 
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router